export var NNBSP = "\u202F";